import React from 'react'
import styles from "./contact.module.scss"

const encode = (data) => {
return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class Contact extends React.Component {
    constructor(props) {

		super(props);
		this.initialState = { name: "", email: "", message: "", sent: false}
		this.state = this.initialState;
    }

    handleSubmit = e => {
    	e.preventDefault();
    	
    	if (this.state.sent) {
    		return
    	}

		fetch("/", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: encode({ "form-name": "contact", ...this.state })
		})
		.then(() => {
			this.formSuccess();
		})
		.catch(error => alert(error));
    };

    formSuccess = () => {
    	this.setState({
			sent: true
    	})

    	setTimeout( () => {
	    	this.returnToInitialState();
    	}, 3000)
    };

    returnToInitialState = () => {
		this.setState(this.initialState)
    }
 	
 	handleChange = e => {
 		this.setState({ [e.target.name]: e.target.value })
 	};

    render() {
    	const { name, email, message } = this.state
    	const submitMessage = this.state.sent ? 'Your message has been sent' : 'Send';
		return (
			<div className={styles.container}>
				<div className={styles.inner}>
				    <h1 className={styles.title}>Contact</h1>
				    <form
				      className={styles.form} onSubmit={this.handleSubmit}
				    >
				      <div className={styles.topTextContainer}>
				          <div className={styles.inputContainer}>
				            <label>
				              <span className={styles.labelText}>Your name:</span>
				              <input className={styles.input} type="text" name="name" value={name} onChange={this.handleChange} />
				            </label>
				          </div>
				          <div className={styles.inputContainer}>
				            <label>
				              <span className={styles.labelText}>Your email:</span>
				              <input className={styles.input} type="email" name="email" value={email} onChange={this.handleChange} />
				            </label>
				          </div>
				      </div>
				      <div>
				        <label>
				          <span className={styles.labelText}>Message:</span>
				          <textarea name="message"  className={styles.message} value={message} onChange={this.handleChange} />
				        </label>
				      </div>
				      <div>
				        <button type="submit" className={styles.submit}>{submitMessage}</button>
				      </div>
				    </form>
				</div>
	    	</div>
		)
	}
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js